import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/LabsModule/LabsModule.tsx");
